import { Link } from "react-router-dom";

const areas = [
  { city: "Santa Monica", detail: "Primary Studio Location" },
  { city: "Brentwood", detail: "Residential & Hillside" },
  { city: "Pacific Palisades", detail: "Coastal Residential" },
  { city: "Malibu", detail: "Coastal Estates" },
  { city: "Venice", detail: "Urban & Infill" },
  { city: "Beverly Hills", detail: "Luxury Residential" },
  { city: "Culver City", detail: "Mixed-Use & Commercial" },
  { city: "West Hollywood", detail: "Hospitality & Commercial" },
  { city: "Mar Vista", detail: "Residential & ADU" },
  { city: "El Segundo", detail: "Commercial & Development" },
];

export default function ServiceAreas() {
  return (
    <section className="py-20 lg:py-28 bg-white border-t border-arch-border">
      {/* Map + Content split */}
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[480px]">
        {/* Google Map */}
        <div className="relative h-72 lg:h-auto min-h-[340px]">
          <iframe
            title="Studio 1323 — Santa Monica Architecture Firm Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26446.51777!2d-118.5106!3d34.0195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2a4cec2910019%3A0xb4170b5e238487c0!2sSanta%20Monica%2C%20CA%2090403!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus"
            className="w-full h-full border-0 grayscale"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
          {/* Studio pin label */}
          <div className="absolute bottom-5 left-5 bg-white border border-arch-border px-4 py-3 rounded-lg">
            <p className="text-arch-charcoal text-xs font-semibold tracking-wide">Studio 1323</p>
            <p className="text-arch-gray text-xs font-light">1323 Montana Ave · Santa Monica</p>
          </div>
        </div>

        {/* Content */}
        <div className="px-8 lg:px-14 py-12 lg:py-16 bg-arch-cream">
          <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-3">Where We Work</p>
          <h2 className="font-serif text-3xl lg:text-4xl text-arch-charcoal font-light leading-tight mb-4">
            Serving Santa Monica<br />&amp; Greater Los Angeles
          </h2>
          <p className="text-arch-gray text-sm font-light leading-relaxed mb-8 max-w-sm">
            Based on Montana Avenue in Santa Monica, Studio 1323 takes on residential, multi-family, and hospitality projects throughout the greater Los Angeles area.
          </p>

          <div className="grid grid-cols-2 gap-x-6 gap-y-3 mb-8">
            {areas.map((area) => (
              <div key={area.city} className="flex items-start gap-2">
                <i className="ri-map-pin-2-line text-arch-light text-xs mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-arch-charcoal text-xs font-medium">{area.city}</p>
                  <p className="text-arch-light text-xs font-light">{area.detail}</p>
                </div>
              </div>
            ))}
          </div>

          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-arch-charcoal text-white px-6 py-3 text-xs tracking-[0.15em] uppercase font-medium hover:bg-arch-black transition-all rounded-md cursor-pointer whitespace-nowrap"
          >
            Request a Consultation
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
